import { useFormik, FormikProvider } from "formik";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ProgressBar } from "primereact/progressbar";
import { Message } from "primereact/message";
import { studentsApi } from "../../services/students/studentsApi";
import { academicYearsApi } from "../../services/nomenclatures/academicYearsApi";
import { useState } from "react";
import SemesterAttestationFormFields from "./SemesterAttestationFormFields";

interface MassAttestationDialogProps {
  visible: boolean;
  onHide: () => void;
  studentIds: number[];
}

type FormValues = {
  semester: number;
  academicYearId: number | null;
  attestationDate: Date | null;
  semesterAttestationTypeId: number | null;
};

const MassAttestationDialog = ({ visible, onHide, studentIds }: MassAttestationDialogProps) => {
  const [addAttestation] = studentsApi.useAddStudentSemesterAttestationMutation();
  const { data: currentAcademicYear } = academicYearsApi.useGetCurrentAcademicYearIdQuery();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const formik = useFormik<FormValues>({
    initialValues: {
      semester: 1,
      academicYearId: currentAcademicYear?.data ?? null,
      attestationDate: null,
      semesterAttestationTypeId: null,
    },
    onSubmit: async (values) => {
      setIsProcessing(true);
      setError(null);
      try {
        for (const studentId of studentIds) {
          await addAttestation({
            studentSemesterAttestationId: 0,
            studentId,
            semester: values.semester,
            academicYearId: values.academicYearId ?? currentAcademicYear?.data ?? 0,
            attestationDate: values.attestationDate,
            semesterAttestationTypeId: values.semesterAttestationTypeId ?? 0,
          }).unwrap();
        }
        formik.resetForm();

        onHide();
      } catch (err) {
        setError("Възникна грешка при масовата заверка на студентите.");
      } finally {
        setIsProcessing(false);
      }
    },
  });

  const footer = (
    <div>
      <Button label="Отказ" icon="pi pi-times" onClick={onHide} className="p-button-text" />
      <Button label="Заверка" icon="pi pi-check" onClick={() => formik.handleSubmit()} disabled={isProcessing} />
    </div>
  );

  return (
    <Dialog
      header="Масова заверка на студенти"
      visible={visible}
      onHide={onHide}
      footer={footer}
      style={{ width: "50vw" }}
    >
      <FormikProvider value={formik}>
        <div className="flex flex-column gap-3">
          {error && <Message severity="error" text={error} />}
          {isProcessing && (
            <div className="mb-3">
              <ProgressBar mode="indeterminate" />
              <small className="block mt-2">Обработват се {studentIds.length} студента...</small>
            </div>
          )}
          <SemesterAttestationFormFields />
        </div>
      </FormikProvider>
    </Dialog>
  );
};

export default MassAttestationDialog;
